import { atom } from 'jotai';
import { AdminMFRRestrictionModel } from './mfr_edit_restrictions_types';
import { modelVM } from './mfr_restrictions_models';

export const editRestrictionModelAtom = atom<AdminMFRRestrictionModel>(modelVM());
